module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/stadium.8fb58b36.svg";